module.exports = __webpack_public_path__ + "media/landing_page/expand-9a9ba3b4.svg";